import { render, staticRenderFns } from "./view403.vue?vue&type=template&id=469d412d&scoped=true&lang=pug&"
import script from "./view403.vue?vue&type=script&lang=js&"
export * from "./view403.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469d412d",
  null
  
)

export default component.exports